export class ProductForm {
  constructor(
    endPointUrl,
    formId,
    modalId,
    formErrorsId,
    tokenId,
    handleVariants = false,
    useTelephone = false,
    refreshAfterSuccess = false
  ) {
    this.useTelephone = useTelephone;
    this.modal = document.getElementById(modalId);
    this.refreshAfterSuccess = refreshAfterSuccess;
    this.listen(
      endPointUrl,
      formId,
      modalId,
      formErrorsId,
      tokenId,
      handleVariants
    );
  }

  async listen(
    endPointUrl,
    formId,
    modalId,
    formErrorsId,
    tokenId,
    handleVariants
  ) {
    const form = document.getElementById(formId);
    if (form) {
      const apiUrl = form.getAttribute("action");
      if (apiUrl) {
        endPointUrl = apiUrl;
      }
      if (handleVariants) {
        const hashParam = window.location.hash.substring(1);
        this.selectVariant(hashParam);
      }
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const inputs = form.querySelectorAll("input, textarea, select");
        let isValid = true;
        inputs.forEach((input) => {
          if (input.offsetParent !== null && !input.checkValidity()) {
            input.reportValidity();
            isValid = false;
          }
        });
        if (isValid) {
          const recaptchaEl = document.getElementById("js-recaptcha");
          const rSiteKey = recaptchaEl
            ? JSON.parse(recaptchaEl.innerText)?.siteKey
            : null;
          if (rSiteKey) {
            let id = "js-recaptcha-v3";
            let script = document.getElementById(id);
            if (script) {
              script.remove();
            }
            try {
              script = document.createElement("script");
              script.type = "text/javascript";
              script.id = id;
              script.src = `https://www.google.com/recaptcha/api.js?render=${rSiteKey}`;
              document.head.appendChild(script);
            } catch (e) {}
            script?.addEventListener("load", () => {
              grecaptcha.ready(() => {
                grecaptcha
                  .execute(rSiteKey, { action: "submit" })
                  .then(async (token) => {
                    const tokenEl = document.getElementById(tokenId);
                    if (tokenEl) {
                      tokenEl.value = token;
                    }
                    await this.submit(
                      formId,
                      modalId,
                      formErrorsId,
                      endPointUrl,
                      token
                    );
                  })
                  .catch((e) => console.log(e));
              });
            });
          } else {
            await this.submit(formId, modalId, formErrorsId, endPointUrl);
          }
        }
      });
    }

    if (handleVariants) {
      window.addEventListener(
        "hashchange",
        () => {
          const hashParam = window.location.hash.substring(1);
          this.selectVariant(hashParam);
        },
        false
      );
    }
  }

  async submit(formId, modalId, formErrorsId, endPointUrl, token) {
    const form = document.getElementById(formId);
    const { parseFormData } = await import("./helpers");
    let formData = new FormData(form);
    let parsedData = parseFormData(formData);
    if (this.useTelephone) {
      parsedData["phone"] = parsedData.telephone;
      delete parsedData.telephone;
    }
    parsedData["productId"] = document
      .getElementById(formId)
      .getAttribute("data-product");

    const modalLoader = document.querySelector(
      "#" + modalId + " .modal-loader"
    );
    modalLoader?.classList?.add("active");
    fetch(endPointUrl, {
      method: "POST",
      body: JSON.stringify({ ...parsedData, token }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (payload) => {
        if (payload.state === "success") {
          const modal = document.getElementById(modalId);
          if (this.refreshAfterSuccess) {
            modalLoader?.classList.remove("active");
            modal.style.display = "none";
            document
              .querySelectorAll(".modal-backdrop")
              .forEach((e) => e.remove());
            this.showAlert(payload.state, payload.message);
            window.location.reload();
            return;
          }

          if (modal) {
            modal.innerHTML = modal.getAttribute("data-success-modal");
          }

          const ratingModalToggle = document.getElementById(
            modalId + "-toggle"
          );
          ratingModalToggle?.remove();
        } else {
          if (payload.errors) {
            const formErrors = document.getElementById(formErrorsId);

            if (formErrors) {
              let errorElement =
                '<div class="alert alert-danger mb-3"><ul class="mb-0">';

              payload.errors.forEach((error) => {
                errorElement += "<li>" + error + "</li>";
              });

              errorElement += "</ul></div>";

              formErrors.innerHTML = errorElement;
            }
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        modalLoader?.classList.remove("active");
      });
  }

  selectVariant(code) {
    const variantOptions = document.getElementById(
      "rPurchaseFormVariantOptions"
    );

    if (variantOptions) {
      const data = JSON.parse(variantOptions.textContent);
      const found = data.variants.find((variant) => variant.code === code);

      if (found) {
        const formSelect = document.getElementById("frm-variant");
        if (formSelect) {
          formSelect.value = found.uuid;
        }
      }
    }
  }

  showAlert(type, message) {
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
    alertDiv.setAttribute("role", "alert");

    alertDiv.innerHTML = `
          ${message}
        `;

    const alertContainer =
      document.querySelector(".site__flashes") || document.body;
    alertContainer.insertBefore(alertDiv, alertContainer.firstChild);
  }
}
